import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class UserRoleService {
  private userRoleSubject = new BehaviorSubject<number>(null); // Default role is null
  userRole$ = this.userRoleSubject.asObservable(); // Observable for role changes

  // Set the user's role
  setUserRole(role: number): void {
    console.log('setUserRole called with:', role);
    this.userRoleSubject.next(role);
  }

  // Get the current user's role
  getUserRole(): number {
    return this.userRoleSubject.value;
  }

  // Initialize the user's role
  initializeUserRole(role: number): void {
    if (this.userRoleSubject.value === null) {
      console.log('initializeUserRole called with:', role);
      this.userRoleSubject.next(role);
    }
  }


  constructor() { }
}
